import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=ac65179c&scoped=true&lang=pug&"
import script from "./OrderConfirm.vue?vue&type=script&lang=js&"
export * from "./OrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&id=ac65179c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac65179c",
  null
  
)

export default component.exports